import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Country } from '../models/country.model';
import { ApplicationSettings } from 'lib-config';

@Injectable({
  providedIn:'root'
})
export class CountryService { 

  constructor(private http: HttpClient, private settings: ApplicationSettings) {
        
  }

  getCountries() {
    return this.http.get<Country[]>(this.settings.backendUrlCKT + `/api/CktJurisdiction/all`);
  }
}
